import * as React from "react";
import { useHistory } from "react-router-dom";

import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

import VisibilityIcon from "@material-ui/icons/Visibility";

import { translate } from "jazasoft";

import Tooltip from "../../components/Tooltip";

import { strictMultiLineText, truncate } from "../../utils/helpers";

const getListText = value => {
  let splits = strictMultiLineText(value, 40);
  if (splits.some(e => e.length > 40)) {
    splits = strictMultiLineText(value, 40);
  }
  return splits.join("\n");
};

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: 275,
    height: 70,
    backgroundColor: "#E3E9ED"
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  row1Right: {
    display: "flex",
    alignItems: "center"
  },
  viewIcon: {
    color: "#2c353c",
    marginLeft: 12
  }
});

const FlowInfoCard = ({ record, translate, utc_offset, unitList = [] }) => {
  const classes = useStyles();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    orderId,
    poRef,
    // customerPoRef,
    customerName,
    seasonName,
    productName,
    style,
    color,
    orderQty,
    fpoQty,
    deliveryDate,
    unitId,
    customerFlowRef
  } = record || {};
  const unitName = unitList.find(e => e.unitId === unitId)?.name || unitId || "-";

  const detailList = [
    { label: translate("resources.orders.fields.poRef", { _: "PO Ref." }), value: poRef },
    { label: translate("resources.orders.fields.seasonName", { _: "Season" }), value: seasonName },
    { label: translate("resources.orders.fields.customerName", { _: "Customer" }), value: customerName },
    // { label: translate("resources.orders.fields.customerPoRef", { _: "Customer PO Ref" }), value: customerPoRef },
    { label: translate("resources.orders.fields.flowInfo.productName", { _: "Product" }), value: productName },
    { label: translate("resources.orders.fields.flowInfo.style", { _: "Style" }), value: style },
    { label: translate("resources.orders.fields.flowInfo.color", { _: "Color" }), value: color },
    { label: translate("resources.orders.fields.flowInfo.orderQty", { _: "Order Qty" }), value: orderQty },
    { label: translate("resources.orders.fields.flowInfo.fpoQty", { _: "FPO Qty" }), value: fpoQty },
    { label: translate("resources.orders.fields.flowInfo.deliveryDate", { _: "Delivery Date" }), value: deliveryDate },
    { label: translate("resources.orders.fields.flowInfo.customerFlowRef", { _: "BPO" }), value: customerFlowRef },
    { label: translate("resources.orders.fields.flowInfo.unitId", { _: "Unit" }), value: unitName }
  ];

  return (
    <div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}>
        <div style={{ width: 360 }}>
          <List disablePadding dense={false}>
            {detailList.map(({ label, value }, idx) => (
              <ListItem key={idx} divider>
                <ListItemText primary={label} />
                <ListItemSecondaryAction>
                  <ListItemText style={{ whiteSpace: "pre" }} primary={getListText(value) || value} />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>

      <Paper className={classes.root} square elevation={3}>
        {/** Row1 */}
        <div className={classes.row}>
          <div
            style={{ color: "blue" }}
            onClick={() => history.push(unitList?.length > 1 ? `/order-mngmt/orders/${orderId}/view` : `/orders/${orderId}/view`)}>
            <Tooltip title="PO Ref." placement="right" arrow>
              <Typography>{truncate(poRef, 25)}</Typography>
            </Tooltip>
          </div>

          <div className={classes.row1Right}>
            <div>
              <Tooltip title="qty" placement="left" arrow>
                <Typography>{fpoQty}</Typography>
              </Tooltip>
            </div>
            <VisibilityIcon className={classes.viewIcon} onClick={event => setAnchorEl(event.currentTarget)} />
          </div>
        </div>

        {/** Row2 */}
        <div className={classes.row}>
          <div>
            <Tooltip title="Style" placement="right" arrow>
              <Typography>{`${truncate(style, 15)}`}</Typography>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Product" placement="right" arrow>
              <Typography>{`${truncate(productName, 10)}`}</Typography>
            </Tooltip>
          </div>
        </div>

        {/** Row3 */}
        <div className={classes.row}>
          <div>
            <Tooltip title="Color" placement="left" arrow>
              <Typography>{`${truncate(color, 15)}`}</Typography>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Unit" placement="left" arrow>
              <Typography>{`${truncate(unitName, 10)}`}</Typography>
            </Tooltip>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default translate(FlowInfoCard);
